(function () {
  function initReviewsCarousel(carousel) {
    var track = carousel.querySelector('[id^="Reviews-Track-"]');
    if (!track) return;

    var section = carousel.closest('.reviews');
    var dotsWrapper = section ? section.querySelector('[id^="Reviews-Dots-"]') : null;
    var cards = Array.prototype.slice.call(track.children);
    var dots = dotsWrapper ? Array.prototype.slice.call(dotsWrapper.children) : [];
    var scrollTimeout;

    function scrollToCard(index) {
      var card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    // function updateActiveDot() {
    //   if (!dots.length) return;
    //   var trackRect = track.getBoundingClientRect();
    //   var closestIndex = 0;
    //   var closestDistance = Infinity;

    //   cards.forEach(function (card, index) {
    //     var cardRect = card.getBoundingClientRect();
    //     var distance = Math.abs(cardRect.left - trackRect.left);
    //     if (distance < closestDistance) {
    //       closestDistance = distance;
    //       closestIndex = index;
    //     }
    //   });

    //   dots.forEach(function (dot, index) {
    //     var isActive = index === closestIndex;
    //     dot.classList.toggle('reviews__dot--active', isActive);
    //     dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    //   });
    // }

    function updateActiveDot() {
      if (!dots.length) return;
      var trackRect = track.getBoundingClientRect();
      var closestIndex = 0;
      var closestDistance = Infinity;

      dots.forEach(function (dot, index) {
        var card = cards[index];
        if (!card) return;
        var cardRect = card.getBoundingClientRect();
        var distance = Math.abs(cardRect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        var isActive = index === closestIndex;
        dot.classList.toggle('reviews__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToCard(Number(dot.dataset.index));
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(updateActiveDot, 80);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(updateActiveDot, 80);
    });
  }

  function init() {
    document.querySelectorAll('[data-reviews-carousel]').forEach(initReviewsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-reviews-carousel]');
    if (carousel) initReviewsCarousel(carousel);
  });
})();